export default {
    common: {
        email: '邮箱',
        password: '密码',
        learnMore: '了解更多',
        sendEmail: '发送邮件'
    },
    login: {
        title: '登录 Thundersend.me',
        rememberMe: '记住我',
        forgotPassword: '找回密码',
        login: '登录',
        noAccount: '我还没有账户？',
        register: '注册一个'
    },
    footer: {
        introduce: '闪送 - 您的Web3消息过滤器！',
        privacy: '隐私政策',
        protocal: '服务协议',
        aboutUs: '关于我们',
        toUse: '如何使用',
        contact: '联系我们',
        link: '友情链接',
        home: '首页',
        function: '功能特点',
        subscribe: '热门订阅',
        qa: '常见问题',
        course: '基础教程',
        service: '服务协议',
        privacy: '隐私政策',
    },
    home: {
        hero: {
            title: '闪送，您的Web3消息过滤器',
            subtitle: '闪送帮助web3行业从业者打造个性化频道,帮助您快速过滤Telegram/Twitter(X)中的消息，实现闪电推送',
            startButton: '开始使用',
            tutorialButton: '教学视频'
        },
        features: {
            title: 'Thundersend的主要特点',
            subtitle: '通过闪送，您可以轻松从Web3/频道中获取您想要的信息',
            items: {
                subscription: {
                    title: '海量热门订阅',
                    description: '闪送为web3/加密货币行业用户内置了海量热门的消息热门订阅，您可以复制这些热门订阅快速实现您的筛选诉求。'
                },
                filter: {
                    title: '灵活的关键词筛选',
                    description: '您可以通过可视化配置实现多种复杂的关键词组合进行过滤，例如包含/排除/大于/小于等。'
                },
                push: {
                    title: '多种收听方式',
                    description: '您可以将过滤后的消息通过Telegram/企微Work wechat/飞书Lark等多种IM工具进行实时推送。'
                },
                test: {
                    title: '快捷的测试工具',
                    description: '通过过滤器和推送机器人测试工具，您可以快速验证您的过滤规则和推送通道，方便您快速调整'
                }
            }
        },
        faq: {
            title: '常见问题',
            subtitle: '您在使用闪送服务时可能碰到的问题，这里有解决方法，可以看一下',
            questions: {
                source: {
                    question: '如何确认我提交的消息源（群）已经被收录?',
                    answer: '登录后进入”我的频道“，在左侧消息源列表中搜索到您刚刚添加的消息源，点击消息源名称，如果弹出框中有采集到消息，证明收录成功'
                },
                portal: {
                    question: '如何验证过滤规则?',
                    answer: '登录后进入”我的频道“页面，找到右侧下方您想要验证规则的过滤器，点击编辑后在上方的测试过滤器处您可以手工输入一条消息来验证您的过滤规则'
                },
                rule: {
                    question: '为什么我收不到推送消息?',
                    answer: '可能是您设置的收听方式有问题，请进入”配置我的收听方式“页面，对收听方式的通道进行单独测试:如果收听方式测试通过，那么请测试您的过滤规则。'
                },
                complex: {
                    question: '如何复制公共频道生成我专属的频道?',
                    answer: '您可以在公共频道中点击复制按钮，复制生成您自己的频道(该功能仅限VIP使用)。'
                },
                push: {
                    question: '我想设置复杂的组合过滤规则?',
                    answer: '进入过滤器设置界面，点击过滤规则设置，选择关键词组合设置，您可以将包含、大于、等于、小于、排除等条件通过组合方式进行设置，条件间通过顿号表示并且操作.'
                },
                multiple: {
                    question: '可以在一个过滤器中同时过滤多个消息源的消息吗?',
                    answer: '系统支持在一个过滤器中设置多个消息源，并且在各个条件设置中，逗号表示或者，顿号表示并且。'
                }
            }
        },
        contact: {
            title: '联系我们',
            subtitle: '通过官方Telegram支持群',
            social: {
                twitter: {
                    title: '官方X/twitter',
                    handle: '@thundersendme'
                },
                telegram: {
                    title: '官方Telegram支持群（推荐）',
                    chinese: {
                        label: '中文群：',
                        handle: '@thundersendSupport_CN'
                    },
                    english: {
                        label: '英文群：',
                        handle: '@thundersendSupport_EN'
                    }
                },
                email: {
                    title: '联系邮箱'
                }
            },
            email: {
                title: '发邮件给我们',
                recipient: 'Official thundersend',
                emailAddress: 'service@thundersend.me',
                placeholder: '您的建议'
            }
        }
    },
    channel: {
        banner: {
            desc: '监听公共频道，把控市场动向',
            title: '公共频道'
        },
        stats: {
            owner: '所有者',
            sources: '消息源',
            followers: '关注人数',
            tags: '标签'
        },
        button: {
            copy: '复制这个频道(限VIP)',
            listen: '收听这个频道',
            cancelListen: '取消收听'
        },
        content: {
            latest: '最新消息',
            statistics: '分发统计'
        }
    },
    config: {
        banner: {
            desc: '您可以增加多个收听方式来接收取消',
            title: '配置我的收听方式'
        },
        notice: '闪送允许你通过多种方式来收听频道消息，您可以在此处配置多种收听方式',
        methods: {
            telegram: {
                title: '方式1: 通过Telegram上的机器人来接听'
            },
            wechat: {
                title: '方式2: 通过企业微信Webhook机器人来接听'
            },
            feishu: {
                title: '方式3: 通过飞书Webhook机器人来接听'
            },
            custom: {
                title: '方式4: 通过自定义Webhook机器人来接听'
            },
            vipTip: '* 在该方式下添加新的收听通道(仅限VIP)'
        },
        form: {
            labels: {
                telegramBot: 'Telegram机器人',
                uniqueId: '收听方式唯一号',
                robotUrl: '企业机器人地址',
                testChannel: '测试收听通道',
                returnStatus: '返回状态',
                returnResult: '返回结果'
            },
            placeholders: {
                telegramBot: 'thundersend_bot',
                autoGenerate: '自动生成',
                wechatWebhook: '请输入企业微信webhook机器人地址',
                testMessage: '请输入测试消息',
                customName: '个性化名称',
                feishuWebhook: '请输入飞书webhook机器人地址',
                customWebhook: '请输入自定义webhook机器人地址'
            }
        },
        button: {
            addFriend: '添加好友',
            save: '保存',
            test: '测试该通道',
            testConnection: '测试连通',
            sendTest: '发送测试消息',
            cancel: '作废',
            bindSuccess: '绑定成功',
            bindFail: '绑定失败',
            notFoundAccount: '未找到绑定的Telegram账号',
            telegramInfo: '首次绑定Teleqram机器人，请先点击下方添加好友按钮，到telegram中的thunsersendme bot会话中点击start，然后回本页面保存即可;如果绑定失败，请作废后重新绑定'
        }
    },
    layout: {
        menu: {
            home: '首页',
            hot: '公共频道',
            mine: '我的频道',
            insight: '洞察',
            subscribe: '订阅',
            notice: '公告'
        },
        button: {
            login: '登录',
            onLight: '开灯',
            closeLight: '关灯'
        }
    },
    hot: {
        banner: {
            desc: '监听公共频道，把控市场动向',
            title: '公共频道'
        },
        stats: {
            channels: '频道数',
            sources: '消息源',
            followers: '关注人数'
        },
        button: {
            createChannel: '创建我的频道',
            listenSetting: '配置我的收听方式',
            listen: '收听频道',
            unlisten: '取消收听',
            copyChannel: '复制这个频道(限VIP)'
        },
        list: {
            channel: '频道',
            popular: '热门',
            latest: '最新',
            tag: '标签',
            allTags: '全部',
            jumpChannel: '没有找到您想要的频道？点此创建您的专属频道'
        },
        search: {
            placeholder: '请输入关键词'
        },
        table: {
            channel: '频道',
            tags: '标签',
            sources: '消息源',
            followers: '订阅人数',
            pushMethod: '收听方式',
            actions: '操作',
            unit: '个',
            person: '人'
        }
    },
    insight: {
        banner: {
            desc: '洞察热门合约，币种/KOL，寻找投资',
            title: '洞察'
        },
        card: {
            project: {
                title: '热门项目'
            },
            currency: {
                title: '热门币种'
            },
            kol: {
                title: '热门KOL'
            }
        },
        filter: {
            chainType: '链类型',
            timeType: '时间类型'
        },
        table: {
            rank: '排行',
            contract: '合约/地址号',
            amount: '数量',
            currency: '币种',
            kol: '推特/X用户名'
        },
        button: {
            copy: '复制',
            insight: '洞察',
            back: '返回'
        },
        kol: {
            name: '名称',
            account: '@账号'
        },
        content: {
            latest: '最新消息',
            statistics: '分发统计',
            timeWarning: '免费会员不支持切换时间'
        }
    },
    mine: {
        banner: {
            desc: '创建我的专属频道（灵活定义过滤条件）',
            title: '我的频道'
        },
        source: {
            title: 'Telegram 消息源',
            button: {
                new: '新消息源'
            },
            tags: {
                all: '全部'
            },
            search: {
                placeholder: '使用群(频道)名/账号名/URL查询'
            }
        },
        form: {
            title: {
                create: '创建新频道',
                edit: '编辑频道'
            },
            label: {
                name: '频道名称',
                no: '频道编号',
                source: '消息源',
                rules: '设置规则',
                showRules: '消息中显示规则',
                pushRobot: '收听方式',
                isPublic: '是否公开',
                customWords: '个性化名称'
            },
            placeholder: {
                name: '请输入频道名称',
                no: '请输入频道编号',
                customWords: '请输入个性化名称'
            },
            button: {
                chooseSource: '选择消息源',
                setRules: '设置消息内容过滤规则'
            },
            radio: {
                show: '显示',
                hide: '不显示',
                yes: '是',
                no: '否'
            },
            noRules: '未设置条件'
        },
        test: {
            title: '频道测试',
            label: {
                input: '测试消息输入',
                status: '返回状态',
                result: '返回結果'
            }
        },
        channel: {
            search: {
                placeholder: '使用关键字搜索'
            },
            button: {
                configListen: '配置收听方式',
                addListen: '+新增收听方式'
            }
        },
        table: {
            channel: '我创建的频道',
            status: '状态',
            source: '消息源',
            listenMethod: '收听方式',
            actions: '操作'
        },
        button: {
            save: '保存',
            cancel: '取消',
            test: '测试',
            edit: '编辑',
            invalid: '作废'
        }
    },
    notice: {
        banner: {
            title: '公告信息'
        },
        list: {
            time: '时间',
            desc: '描述'
        },
        dialog: {
            title: '公告详情',
            content: '内容'
        }
    },
    profile: {
        user: {
            logout: '退出',
            registerTime: '注册于{time}',
            loginTime: '上次登录时间：{time}',
            memberExpiry: '会员到期日',
            inviteButton: '邀请好友延长会员期'
        },
        info: {
            title: '基本信息',
            email: '邮箱',
            nickname: '昵称',
            inviteCode: '邀请码',
            copyInvite: '复制邀请码链接',
            lastModified: '最后修改'
        },
        security: {
            title: '安全信息',
            loginMethod: '登录方式',
            emailPassword: '邮箱+密码',
            password: '登录密码',
            emailVerification: '邮箱验证码',
            changePassword: '修改密码'
        },
        stats: {
            title: '概况',
            subscribed: '我订阅的频道',
            created: '我创建的频道',
            pushed: '7天内已推送消息数'
        },
        action: {
            manageSource: '管理消息源',
            manageListen: '管理收听方式'
        },
        invite: {
            title: '我邀请的用户',
            invitedUser: '邀请了用户',
            noData: '暂无邀请记录'
        }
    },
    subscribe: {
        title: '我们的会员体系',
        plans: {
            period: '/月',
            free: {
                title: '普通用户',
                features: {
                    sources: '{count} 消息源',
                    channels: '{count} 订阅频道/ {count} 专属频道',
                    methods: '收听方式/通道',
                    telegram: 'Telegram - 支持',
                    wecom: '企业微信 - 不支持',
                    feishu: '飞书 - 不支持',
                    webhook: '自定义Webhook - 不支持',
                    interval: '1 分钟/推送间隔'
                }
            },
            vip: {
                title: 'VIP会员',
                features: {
                    sources: '{count} 消息源',
                    channels: '{count} 订阅频道/ {count} 专属频道',
                    methods: '收听方式/通道',
                    telegram: 'Telegram - 支持',
                    wecom: '企业微信 - 多通道支持',
                    feishu: '飞书 - 多通道支持',
                    webhook: '自定义Webhook - 不支持',
                    realtime: '实时推送'
                }
            },
            svip: {
                title: '超级SVIP会员',
                features: {
                    sources: '无限消息源',
                    channels: '{count} 订阅频道/ {count} 专属频道',
                    methods: '收听方式/通道',
                    telegram: 'Telegram - 支持',
                    wecom: '企业微信 - 多通道支持',
                    feishu: '飞书 - 多通道支持',
                    webhook: '自定义Webhook - 多通道支持',
                    realtime: '实时推送'
                }
            }
        },
        button: {
            join: '立即加入',
            buy: '立即购买',
            link: '立即联系'
        },
        dialog: {
            payment: {
                scan: '请扫码后支付USDT代币',
                binance: '您也可以通过币安ID【910336933】转账支付',
                reminder: '特别提醒：支付时请输入您的注册邮箱'
            }
        }
    },
    rulesSettingPlaceholder: {
        notsetting: "未设置条件时，请留空",
        include: "包含多个关键词使用逗号“，”隔开，表示只要包含任何一个关键词就满足条件",
        exclude: "排除多个关键词使用逗号“，”隔开，表示不包含任何一个关键词时才满足条件",
        greaterthan: "余额：>10, “余额”为关键词，“：”为识别后方值的分隔符",
        equalto: "余额：=10, “余额”为关键词，“：”为识别后方值的分隔符",
        lessthan: "余额：<10, “余额”为关键词，“：”为识别后方值的分隔符",
        inccontract: "合约类型，如：eth,sol，匹配多个合约类型请逗号隔开",
        aiprompt: "每个条件之间顿号“、”隔开，只有每个条件都成立时匹配才成功",
        defaultValue: "包含[关键词1,关键词2]、排除[关键词3]、关键词4>0、关键词5<1500",
        greaterthanWarning: "不支持使用 < 和 = 符号！",
        equaltoWarning: "不支持使用 < 和 > 符号！",
        lessthanWarning: "不支持使用 > 和 = 符号！"
    },
    loginPage: {
        emailRequired: '请输入邮箱地址',
        passwordRequired: '请输入密码',
        loginSuccess: '登录成功',
        loginFailed: '登录失败',
    },
    reset: {
        resetPassward: '重置密码',
        getCode: '获取验证码',
        emailRequired: '请输入您的邮箱地址',
        codeRequired: '请输入重置验证码',
        next: '下一步',
        goBack: '返回',
        vaildEamil: '请输入正确的邮箱地址',
        verCodeRequired: '请输入验证码',
        resetSuccess: '重置密码成功',
        resetFailed: '重置密码失败',
        verCodeSend: '验证码已发送',
    },
    minePage: {
        fold: '收起',
        more: '更多',
        filterTag: '过滤器标签',
        addTag: '添加标签',
        countUnit: '个',
        rule: '规则',
        connector: '连接符',
        or: '或',
        and: '与',
        confirm: '确定',
        cancel: '取消',
        addSource: '新消息源',
        editSource: '编辑消息源',
        serialNumber: '编号',
        sourceUrl: '消息源地址',
        sourceAccount: '消息源账号',
        sourceName: '消息源名称',
        customName: '自定义名称',
        sourceTag: '消息源标签',
        selectSource: '请选择我的(或公共的)消息源',
        commonSource: '公共消息源',
        mySource: '我的消息源',
        quickSearch: '快速搜索',
        name: '名称',
        search: '查询',
        reset: '重置',
        selectSourceTip: '请选择数据源',
    },
    register: {
        register: '注册',
        enterEmail: '请输入您的邮箱',
        enterPassword: '请输入您的密码',
        enterVerCode: '请输入邮箱验证码',
        inviteCode: '邀请码（选填）',
        hadAccount: '已有账号',
        clickLogin: '点击登录',
        validPassword: '密码长度不能小于6位',
        registerSuccess: '注册成功',
    },
    hotPage: {
        createAt: '创建于',
    },
    profileJs: {
        before: '前',
        copySuccess: '复制成功',

    },
    insightJs: {
        minutes: '分钟',
        getDataFailed: '获取数据失败'
    },
    channelJs: {
        listenSuccess: '收听成功',
        confirmUnlisten: '确定取消收听频道？',
        tip: '提示',
        unlistenSuccess: '取消收听成功',
    },
    hotJs: {
        defaultSort: '默认排序',
        subscribeCount: '订阅数量',
        latest: '最新',
        sort: '排序',
        selectPushWay: '请选择收听方式',
    },
    configJs: {
        customReamrk: '请补充个性化名称',
        customRemarkUsed: '个性化名称已存在',
        saveSuccess: '保存成功',
        saveFailed: '保存失败，请稍后重试',
        confirmCancelRobot: '确定要作废该收听方式吗？',
        cancelSuccess: '作废成功',
    },
    commonJs: {
        day: '天',
        hour: '小时',
        minute: '分钟',
        second: '秒',
    },
    mineSources: {
        title: '消息源管理',
        subTitle: '我的消息源',
        addSource: '新增消息源',
        editSource: '编辑消息源',
        tags: '消息源标签',
        pleaseMsgUrl: '请输入消息源地址',
        deleteConfirm: '作废后将不再推送该消息源的消息，是否确认作废？',
        prompt: '提示',
        deleteSuccess: '作废成功',
        validUrl: 'URL不合法',
        warning1: '系统不支持Telegram_bot机器人地址，请输入Telegram group群！',
        warning2: '该地址不是有效的Telegram链接！',
        inputCustomName: '请输入个性化名称',
        selectSource: '请选择消息源',
        selectRobot: '请选择收听方式',
        deleteFilterConfirm: '确定作废该过滤器吗？',
        channerSearChPlaceholder: '名称/消息源地址/消息源账号',
        loginListener: '登录后收听',
        mineListener: '我收听的',
        sendMsgNum: '已推送消息数',
        select: '选择',
        comingSoon: '即将上线',
        freeCopayWarning: '免费会员不支持复制频道',
        memberType: '会员类型',
        membership: '查看会员权益计划',
        autoGenerate: '自动生成',
        inputNameWarning: '请输入名称',
        generInviteCode: '生成邀请码',
        remark: '使用说明',
        stop: '停止',
        enable: '启动',
        copyInfo: '复制信息',
        copyInfoSuccess: '频道信息已复制',
        linkShared: '链接分享',
        copyLink: '复制链接',
        sendService: '超高速推送服务',
        linkCustomService: '联系客服',
        publicSource: '公共消息源不允许作废'
    }
}